import { ProtectedRoute } from "@/components/protected-route";
import { ChoreSchedulesPage } from "@/pages/chore-schedules";
import { ChoreScheduleDetailPage } from "@/pages/chore-schedule-detail";
import { LoginPage } from "@/pages/login";
import { Navigate, Route, Routes } from "react-router-dom";
import { ChorePage } from "./pages/chore";
import { ChoreHistoryPage } from "./pages/chore-history";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/chore-schedules"
        element={
          <ProtectedRoute>
            <ChoreSchedulesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chore-schedules/:id"
        element={
          <ProtectedRoute>
            <ChoreScheduleDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chore-schedules/:choreScheduleId/chores/:choreId"
        element={
          <ProtectedRoute>
            <ChorePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chore-history"
        element={
          <ProtectedRoute>
            <ChoreHistoryPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/chore-schedules" replace />} />
    </Routes>
  );
}
